export default "__VITE_ASSET__CMrFYJfO__"